import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router }       from '@angular/router';
import { Location }                     from '@angular/common';

import { GroupService }                 from '../../../group.service';
import { Wave }                         from './../../../../../models/program/wave';
import { Group }                        from './../../../../../models/program/group';
import { WaveSingle }                   from './../../../../../models/program/wave-single';

import { Observable }                   from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { GroupRefreshService } from '../../group-refresh.service';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.less']
})

export class GroupComponent implements OnInit, OnDestroy {
  public liveWaveGroupsCache$: Observable<Group[][]> = Observable.of([]);
  public archivedWaveGroupsCache$: Observable<Group[][]> = Observable.of([]);
  private subs: Subscription[] = [];
  public parentRouteId: number;
  public waveSettings: WaveSingle;
  public groupArray: Array<any> = [];
  public liveGroups$: Observable<Group[]> = Observable.of([]);
  public archivedGroups$: Observable<Group[]>;
  public liveWaves: Wave[];
  public archivedWaves: Wave[];
  public confirmDeleteGroup = false;
  public moveSingle = false;
  public settings = false;
  public waveEdit = false;
  public selectedGroupWave: number;
  public waves: Wave[];
  public showArchived = false;
  public groupForAction: Group;
  public componentContext: 'program-parent' | 'wave-parent';
  private loneWaveId: number;

  constructor(
    private groupService: GroupService,
    private groupRefreshService: GroupRefreshService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router
  ) { }

  ngOnInit(): void {

    // http://localhost:4200/dashboard/programs/93/groups
    // http://localhost:4200/dashboard/programs/93/waves/23/

    this.subs.push(
      this.route.parent.url.subscribe(urlArray => urlArray[0].path === 'waves' ?
        this.componentContext = 'wave-parent' : this.componentContext = 'program-parent'
      )
    )

    this.subs.push(
      this.groupRefreshService.refreshGroupList.subscribe(() => {
        this.loadData(this.parentRouteId, true);
      })
    )

    if (this.componentContext === 'wave-parent') {
      this.subs.push(this.route
        .parent
        .parent
        .params
        .subscribe(params => this.parentRouteId = +params['id'])
      );
      this.subs.push(this.route
        .parent
        .params
        .subscribe(params => this.loneWaveId = +params['groupId'])
      );
    } else if (this.componentContext === 'program-parent') {
      this.subs.push(this.route
        .parent
        .params
        .subscribe(params => this.parentRouteId = +params['id'])
      );
    }


    this.loadData(this.parentRouteId);
  }

  /**
   * Public Methods
   */
  public checkGroupArray(checked: boolean, id: number): void {
    if (checked) {
      this.groupArray.push(id);
    } else {
      this.groupArray.splice(this.groupArray.indexOf(id), 1);
    }
  }

  public closeDeleteDialogue(recall: boolean): void {
    if (recall) {
      this.confirmDeleteGroup = false;
      this.loadData(this.parentRouteId, recall);
    } else {
      this.confirmDeleteGroup = false;
    }
  }

  public closeMoveSingle(recall: boolean): void {
    if (recall) {
      this.waves = null;
      this.moveSingle = false;
      this.loadData(this.parentRouteId, recall);
    } else {
      this.moveSingle = false;
    }
  }

  public getWaveSettings(id: number): void {
    this.waveSettings = null;
    this.groupService.getWave(this.parentRouteId, id)
                     .subscribe(wave => {
                       this.waveSettings = wave;
                     });
  }

  public tableWaveNumber(index: number): number {
    // return the wave number (for styling) from the 0-based index of the wave
    return (index % 2) + 1;
  }

  public closeManager(recall: boolean): void {
    if (recall) {
      this.clearGroups();
      this.loadData(this.parentRouteId, recall);
    } else {
      this.clearGroups();
    }
  }

  public closeDrawer(reset: boolean, type: string): void {
    if (type === 'wave') {
      this.waveEdit = false;
      this.waveSettings = null;
      this.loadData(this.parentRouteId, reset);
    }
  }

  public groupMenuItemSelected(item: string, group: Group, wave?: number) {
    this.groupForAction = group;
    this.selectedGroupWave = wave;
    if (item === 'move') {
      this.moveSingle = !this.moveSingle;
    } else if (item === 'delete') {
      this.confirmDeleteGroup = !this.confirmDeleteGroup;
    } else if (item === 'open') {
      window.open(`/library?groupselect=${group.id}`);
    }
  }

  public goToWave(waveId: number) {
    this.router.navigate(['../waves/', waveId], {relativeTo: this.route});
  }

  /**
   * Private Methods
   */

  private loadData(programId: number, reset?: boolean): void {
    if (reset) {
      this.liveWaveGroupsCache$ = Observable.of([]);
      this.archivedWaveGroupsCache$ = Observable.of([]);
    }

    if (this.componentContext === 'program-parent') {
      this.liveGroups$ = this.groupService.getLoneGroups(programId, 'live');
      this.archivedGroups$ = this.groupService.getLoneGroups(programId, 'archived');
      this.groupService.getWaves(programId, 'live').subscribe(waves => {
        this.liveWaves = waves;
        this.liveWaveGroupsCache$ = this.createForkJoin(waves, 'live')
      });
      this.groupService.getWaves(programId, 'archives').subscribe(waves => {
        this.archivedWaves = waves;
        this.archivedWaveGroupsCache$ = this.createForkJoin(waves, 'archived')
      });
    } else if (this.componentContext === 'wave-parent') {
      this.groupService.getWave(programId, this.loneWaveId).subscribe(wave => {
        this.liveWaves = [wave];
        this.liveWaveGroupsCache$ = this.createForkJoin(this.liveWaves)
      });
    }


  }

  private createForkJoin = function(waves: Wave[], liveOrArchived?: string) {
    return (waves && waves.length) ?
      // forkJoin needed for ngIf, to track completion of all Observables within set, to only show waves when all wavegroups are loaded.
      Observable.forkJoin(waves.map(wave => this.groupService.getWaveGroups(this.parentRouteId, wave.id, liveOrArchived))) :
      // This is necessary so that archivedWaveGroupsCache$ | async test passes if waves are empty, to stop loading indicator
      Observable.of([]);
  }

  private clearGroups(): void {
    this.groupArray = [];
  }


  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/group/group.component.ts